import axios from "axios";
import { AxiosHelperSingleton } from "Helpers";
import { HtmlLogicSingleton } from "Logics";
import { TOpenGraphMetadata, TSpecificationUnitDTO, TSupplierDTO } from "Types";

export class SupplierController {
    private readonly titleNaming = "og:title";
    private readonly imageNaming = "og:image";
    private readonly localeNaming = "og:locale";
    private readonly siteNameNaming = "og:site_name";
    private readonly typeNaming = "og:type";
    private readonly descriptionNaming = "og:description";

    public async getOpenGraphAsync(url: string): Promise<TOpenGraphMetadata> {
        const result = await axios.get<{ faviconUrl: string | null | undefined, metadata: {[name: string]: {[name: string]: string}[] }}>
            (`${AxiosHelperSingleton.getServerBaseURL()}api/opengraph/parseUrl?url=${url}`);
        const metadata: TOpenGraphMetadata = { url: url };

        if(this.titleNaming in result.data.metadata && result.data.metadata[this.titleNaming].length > 0) {
            metadata.title = result.data.metadata[this.titleNaming][0].value;
        }
        if(this.imageNaming in result.data.metadata && result.data.metadata[this.imageNaming].length > 0) {
            metadata.image = result.data.metadata[this.imageNaming][0].value;
        }
        if(this.localeNaming in result.data.metadata && result.data.metadata[this.localeNaming].length > 0) {
            metadata.locale = result.data.metadata[this.localeNaming][0].value;
        }
        if(this.siteNameNaming in result.data.metadata && result.data.metadata[this.siteNameNaming].length > 0) {
            metadata.siteName = result.data.metadata[this.siteNameNaming][0].value;
        }
        if(this.descriptionNaming in result.data.metadata && result.data.metadata[this.descriptionNaming].length > 0) {
            metadata.description = HtmlLogicSingleton.decodeHtml(result.data.metadata[this.descriptionNaming][0].value);
        }
        if(this.typeNaming in result.data.metadata && result.data.metadata[this.typeNaming].length > 0) {
            metadata.type = result.data.metadata[this.typeNaming][0].value;
        }
        if(result.data.faviconUrl) {
            metadata.favicon = result.data.faviconUrl;
        }

        return metadata;
    }
    
    public async createAsync(technologyId: number, supplier: TSupplierDTO): Promise<TSupplierDTO> {
        const result = await axios.post<TSpecificationUnitDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/suppliers/create/technology/${technologyId}`,
            supplier);
        return result.data;
    }

    public async updateAsync(supplier: TSupplierDTO): Promise<boolean> {
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/suppliers/${supplier.id}`,
            supplier);
        return result.status === 200;
    }

    public async deleteAsync(id: number): Promise<boolean> {
        const result = await axios.delete(`${AxiosHelperSingleton.getServerBaseURL()}api/suppliers/${id}`);
        return result.status === 200;
    }
}

export const SupplierControllerSingleton = new SupplierController(); 